import type { ReadonlyRecord } from '../../utils'
import { Usecase } from '.'

export class GetApplicationMetadataUsecase extends Usecase {
    invoke (): ReadonlyRecord<string, string> {
        return this.configurationService.getApplicationMetadata()
    }
}
